<template>
  <el-dialog
    :title="isEdit ? '编辑' : pid ? '新建文档' : '新建文件夹'"
    :visible.sync="currentValue"
    custom-class="tree-file-dialog"
    width="400px"
    append-to-body
    :close-on-click-modal="!isShow"
    @open="open"
    @opened="opened">
    <el-input ref="input" v-model="title" placeholder="请输入标题" size="large">
      <template slot="prepend">
        <el-popover
          v-if="pid || dataset.pid"
          placement="bottom"
          width="800"
          popper-class="help-edit-add-dialog"
          ref="popover"
          v-model="isShow"
          trigger="manual">
          <div class="icon-list">
            <div class="item" @click="clearIcon">
              <span>无</span>
            </div>
            <div class="item" v-for="(item, index) in iconList" :key="item.unicode" @click="selectColor(index)">
              <i class="icon iconfont" :class="{['icon' + item.font_class]: true}" :style="{'color': item.color}"></i>
              <el-color-picker ref="colorPick" v-model="item.color" @change="checkColor(item)"></el-color-picker>
            </div>
          </div>
          <span slot="reference" class="letterHover btn" @click="showPopover">
            <i v-if="icon" class="icon iconfont" :class="{[icon]: true}" :style="{'color': color}"></i>
            <span v-else>图标</span>
          </span>
        </el-popover>
      </template>
    </el-input>
    <span slot="footer" class="dialog-footer">
      <span class="cancel text-btn-active" style="margin-right: 24px;" @click="currentValue = false">取消</span>
      <wf-button type="primary" :disabled="!title" @click="check">确定</wf-button>
    </span>
  </el-dialog>
</template>
<script>
import api from '@/services/api/help/help'
import iconList from '@/assets/icon/iconfont.json'
export default {
  props: ['value','pid', 'isEdit', 'dataset'],
  data() {
    return {
      title: '',
      iconList: JSON.parse(JSON.stringify(iconList.glyphs)),
      icon: '',
      color: '',
      isShow: false
    }
  },
  computed: {
    currentValue: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    }
  },
  mounted() {
    document.addEventListener("click", this.bodyCloseMenus)
  },
  beforeDestroy() {
     document.removeEventListener("click", this.bodyCloseMenus)
  },
  methods: {
  bodyCloseMenus(e) {
    console.log(e)
      if (this.$refs.popover && this.$refs.popover.$el && !this.$refs.popover.$el.contains(e.target)) {
        this.isShow = false
      }
    },
    opened() {
      this.$refs.input.focus()
    },
    async check() {
      let result = {}
      if(this.isEdit) {
        result = await api.documentDraftUpdate({id: this.dataset.id, title: this.title, icon: this.icon, color: this.color})
        result.id = Number(result.id)
        result.pid = Number(result.pid)
        this.$emit('update', result)
      } else {
        result = await api.documentSave({title: this.title, pid: this.pid || 0, icon: this.icon, color: this.color})
        this.$emit('success', result)
      }
      if(!this.pid) { // 新建文件夹直接发布
        api.documentDraftUpdateReleaseStatus({id: result.id, release_status: 3})
      }
      this.currentValue = false
    },
    open() {
      this.title = this.dataset.title
      this.icon = this.dataset.icon
      this.color = this.dataset.color
      this.iconList.find(res => {
        if('icon' + res.font_class === this.icon) {
          console.log(res.font_class, this.icon)
          this.$set(res, 'color', this.color)
          return true
        }
      })
    },
    selectColor(idx) {
      let pick = this.$refs.colorPick[idx]
      pick.showPicker = true
    },
    checkColor(item) {
      this.icon = 'icon' + item.font_class
      this.color = item.color
      this.isShow = false
    },
    clearIcon() {
      this.icon = ''
      this.color = ''
      this.isShow = false
    },
    showPopover() {
      this.isShow = true
    }
  }
}
</script>
<style lang="scss">
.help-edit-add-dialog {
  .icon-list {
    display: flex;
    flex-wrap: wrap;
    max-height: 600px;
    overflow-x:hidden;
    padding: 24px;
    i {
      font-size: 24px;
      color: initial;
    }
    .item {
      width: 78px;
      height: 78px;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      box-sizing: border-box;
      position: relative;
      &:hover {
        background-color: rgba(32, 32, 32, 0.04);
      }
      &:active {
        background-color: rgba(32, 32, 32, 0.08);
      }
      border-radius: 4px;
      .el-color-picker {
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        z-index: -999;
        visibility: hidden;
      }
    }
  }
}
.tree-file-dialog {
  .el-dialog__footer {
    padding-top: 20px;
  }
  .el-input-group__prepend {
    line-height: 1px;
  }
}
</style>
